import React from 'react';
var DragAndDropSkeleton = function () { return (React.createElement("div", { className: "bg-sky-blue-lightest text-center p-5" },
    React.createElement("div", { className: "skeleton-line w-50 m-auto" }, "\u00A0"))); };
export default React.memo(DragAndDropSkeleton);
